import { render, staticRenderFns } from "./pemakaian.vue?vue&type=template&id=5fdcc66a&"
import script from "./pemakaian.vue?vue&type=script&lang=js&"
export * from "./pemakaian.vue?vue&type=script&lang=js&"
import style0 from "./pemakaian.vue?vue&type=style&index=0&id=5fdcc66a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports